import { render, staticRenderFns } from "./exemption.vue?vue&type=template&id=7a310447&scoped=true"
import script from "./exemption.vue?vue&type=script&lang=js"
export * from "./exemption.vue?vue&type=script&lang=js"
import style0 from "./exemption.vue?vue&type=style&index=0&id=7a310447&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a310447",
  null
  
)

export default component.exports